import { Component, ViewChild, ElementRef, Input } from '@angular/core';

import { fromEvent, interval, Subscription, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { MiniTracker } from 'huddyapi';


@Component({
	selector: 'bp-widget',
	templateUrl: 'bp-widget.html',
    styleUrls: ['./bp-widget.scss'],
	inputs: ['data', 'caller', 'clearSubject$', 'yesterdayLoaded', 'yesterdayValue']
})
export class BPWidget{
    @Input() clearSubject$ : Subject<boolean>;
    clearSub : Subscription;
    @Input() yesterdayLoaded : boolean;
    @Input() yesterdayValue : number;
	data : MiniTracker;
	disabled: number;

    showLabels : boolean = false;
	caller;
    @ViewChild('bpcanvas', { static: true }) canvas : ElementRef;
    @ViewChild('lowerLabel', { static: true }) lowerLabel : ElementRef;
    @ViewChild('higherLabel', { static: true }) higherLabel : ElementRef;
    @ViewChild('parrentDiv', { static: true }) parentDiv : ElementRef;
    width : number;

    lineMargin : number ;
    observableInitialized : boolean = false;
    sliderLower : Slider;
    sliderHigher : Slider;

    static LINE_OFFSET  : number  = 25;
    static TEXT_OFFSET  : number  = 15;
    static FONT         : string  = '11pt HK Grotesk';
    static HEIGHT       : number  = 50;
    static INSET        : number  = 0;

    static SLIDER_LOWER_COLOR : string = "#A7C2EF";
    static SLIDER_HIGHER_COLOR : string = "#F06D82";
    static NEUTRAL_COLOR : string = "#7f7f7f";
    static DEFAULT_LOWER_NUMBER : number = 72;
    static DEFAULT_HIGHER_NUMBER : number = 115;

	constructor() {

	}
    getYesterday() {
    return this.data.yesterdayValue;
  }
    captureMouseEvents(canvasEl : HTMLCanvasElement) {

        if (!this.observableInitialized) {
            canvasEl.addEventListener('contextmenu', function(e) { 
                  e.preventDefault();
                });
         
            fromEvent(canvasEl, 'touchstart')
              .subscribe((res: TouchEvent) => {
                var touch = res.touches[0];
                  this.handleTouchStart(canvasEl, touch.clientX, touch.clientY);
       
              });
            fromEvent(canvasEl, 'touchmove')
              .subscribe((res: TouchEvent) => {
                  var touch = res.touches[0];
                  this.handleTouchMove(canvasEl, touch.clientX);
              });  
            fromEvent(canvasEl, 'touchend')
              .subscribe((res: TouchEvent) => {
                this.handleTouchEnd(canvasEl);
              });
            fromEvent(canvasEl, 'mousedown')
              .subscribe((res: MouseEvent) => {
                  this.handleTouchStart(canvasEl, res.clientX, res.clientY);
        
              });
            fromEvent(canvasEl, 'mousemove')
              .subscribe((res: MouseEvent) => {
                  this.handleTouchMove(canvasEl, res.clientX);
              });  
            fromEvent(canvasEl, 'mouseup')
              .subscribe((res: MouseEvent) => {
                this.handleTouchEnd(canvasEl);
            });   
            this.observableInitialized = true;
        }
    }

    handleTouchStart(canvasEl : HTMLCanvasElement, clientX : number, clientY : number) {
      var rect = canvasEl.getBoundingClientRect();
     
      var x : number = clientX - rect.left;
      var y : number = clientY - rect.top;
      if ((this.sliderLower) && (this.sliderLower.contains(x, y))) {
          this.sliderLower.setSelected(true);
          this.sliderHigher.setSelected(false);
      }
      if ((this.sliderHigher) && (this.sliderHigher.contains(x, y))) {
          this.sliderHigher.setSelected(true);
           this.sliderLower.setSelected(false);
      }
    }

    handleTouchMove(canvasEl : HTMLCanvasElement, clientX : number) {
      var ctx = canvasEl.getContext("2d");
      var x : number;
      var rect: DOMRect;
      if ((this.sliderLower) && (this.sliderLower.isSelected())) {
        rect = canvasEl.getBoundingClientRect();
        x = clientX - rect.left;
        if ((x >= this.lineMargin) && (x < this.sliderHigher.x))
            this.redraw(x, 1, ctx);
      }
      if ((this.sliderHigher) && (this.sliderHigher.isSelected())) {
          rect = canvasEl.getBoundingClientRect();
          x = clientX - rect.left;
          if ((x > this.sliderLower.x)  && (x <= (this.width - this.lineMargin)))
              this.redraw(x,  2, ctx);
      }       
    }

    handleTouchEnd(canvasEl : HTMLCanvasElement) {
      var ctx = canvasEl.getContext("2d");
      if ((this.sliderLower) && (this.sliderLower.isSelected())) {
        this.sliderLower.setSelected(false);
        this.redraw(this.sliderLower.x, 1, ctx);
      }
      if ((this.sliderHigher) && (this.sliderHigher.isSelected())) {
          this.sliderHigher.setSelected(false);
          this.redraw(this.sliderHigher.x, 2, ctx);
      }
      this.setMeasurement();
    }

    setMeasurement() {
         if ((this.sliderLower) && (this.sliderHigher)) {
            var diastolic : number = this.coordinateToReading(this.sliderLower.x);
            var systolic : number = this.coordinateToReading(this.sliderHigher.x);
            this.data.currentVal = BPWidget.setBloodPressureRating(diastolic, systolic);
            this.data.systolic = systolic;
            this.data.diastolic = diastolic;
            this.data.dirty = true;
         
        }
    }

    isSelected(index : number) : boolean {
        return (index == 1) ? this.sliderLower.isSelected() : this.sliderHigher.isSelected();
    }




    getSelectedWord() : string {
        var ret : string = '';
        if (this.sliderLower && this.sliderHigher && this.sliderHigher.initialized && this.sliderLower.initialized) {
            var diastolic : number = this.coordinateToReading(this.sliderLower.x);
            var systolic : number = this.coordinateToReading(this.sliderHigher.x);
            ret = BPWidget.getBloodPressureLabel(BPWidget.setBloodPressureRating(diastolic, systolic));
        }
        return ret;
    }

    getLowerReading() : string {
        var ret = '';
        if (this.showLabels && this.sliderLower && this.sliderLower.initialized)
           ret =  this.coordinateToReading(this.sliderLower.x).toFixed();
        return ret;
    }

    getHigherReading() : string {
        var ret = '';
        if (this.showLabels && this.sliderHigher && this.sliderHigher.initialized)
           ret = this.coordinateToReading(this.sliderHigher.x).toFixed();
        return ret;
    }

    redrawFromCoordinates(bpd : number, bps : number) {
     
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        var ctx = canvasEl.getContext("2d");
        let lower : number = this.readingToCoordinate(bpd);
        let upper : number = this.readingToCoordinate(bps);
        this.sliderLower.setSelected(false);
        this.sliderHigher.setSelected(false);
        console.log( 'BPWidget','redrawFromCoordinates', bpd, bps, ctx, lower, upper);
        this.redraw(lower, 1, ctx);
        this.redraw(upper, 2, ctx);

    }


    redraw(x : number, slider : number, ctx) {
        ctx.clearRect(0, 0, this.canvas.nativeElement.width,this.canvas.nativeElement.height );
        this.drawBackground(ctx, x, slider);
        this.sliderLower.draw((slider == 1) ? x : this.sliderLower.x, BPWidget.LINE_OFFSET, ctx);
        this.sliderHigher.draw((slider == 2) ? x : this.sliderHigher.x, BPWidget.LINE_OFFSET, ctx);
        this.drawLabels();
    }

    drawLabels() {

      var lowerLabelEL = this.lowerLabel.nativeElement;
      var higherLabelEL = this.higherLabel.nativeElement;
      var llWidth = lowerLabelEL.clientWidth;
        var lltargetLeft = (this.canvas.nativeElement.offsetLeft - (llWidth / 2)) + this.sliderLower.x;
      var hlTargetLeft = this.canvas.nativeElement.offsetLeft - (higherLabelEL.clientWidth / 2) + this.sliderHigher.x;
      if (lltargetLeft + llWidth >= hlTargetLeft) {
          if (this.sliderLower.isSelected()) {
              lltargetLeft = hlTargetLeft - 3 - llWidth;
          } else if (this.sliderHigher.isSelected()) {
              hlTargetLeft = lltargetLeft + 3 + llWidth;
          }
      }
    // MobileLog.logClassLevel(0, 'BPWidget',this.canvas.nativeElement.offsetTop);

      lowerLabelEL.style.top = (this.canvas.nativeElement.offsetTop -9) + 'px';
      lowerLabelEL.style.left = lltargetLeft + 'px';
      higherLabelEL.style.top = (this.canvas.nativeElement.offsetTop-9) + 'px';
      higherLabelEL.style.left = hlTargetLeft + 'px'; 

    }

    ngOnChanges(changes){
        if (this.clearSubject$ && !this.clearSub) {
            // MobileLog.logClassLevel(0, 'SymptomWidget', 'in ngOnChanges setting clearSub');
            this.clearSub = this.clearSubject$.subscribe(b => {
              console.log( 'BPWidget', 'in clearSubSubscribe', b, this.data);
                if (b) {
                    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
                    var ctx = canvasEl.getContext("2d");
                    this.drawInitialState(ctx);
                }
            })
        }
        if (this.canvas) {

            this.data.currentVal = -1;  
            this.width = 375;
            this.lineMargin = 0 * this.width;
           
            const canvasEl : HTMLCanvasElement = this.canvas.nativeElement;
            this.captureMouseEvents(canvasEl);
            

            this.canvas.nativeElement.width = this.width;
            this.canvas.nativeElement.height = BPWidget.HEIGHT;
            var ctx = canvasEl.getContext("2d");
            this.drawInitialState(ctx);
        }
    }

  drawInitialState(ctx) {
    console.log('BPWidget','drawInitialState');
    this.sliderLower = new Slider(this, BPWidget.SLIDER_LOWER_COLOR);
    this.sliderLower.x = this.readingToCoordinate(BPWidget.DEFAULT_LOWER_NUMBER);
    this.sliderLower.selected = false;
    this.sliderHigher = new Slider(this, BPWidget.SLIDER_HIGHER_COLOR);
    this.sliderHigher.selected = false;
    this.sliderHigher.x = this.readingToCoordinate(BPWidget.DEFAULT_HIGHER_NUMBER);
    ctx.clearRect(0, 0, this.canvas.nativeElement.width,this.canvas.nativeElement.height );
    this.drawBackground(ctx, 0, 0);
    this.sliderLower.draw(this.readingToCoordinate(BPWidget.DEFAULT_LOWER_NUMBER), BPWidget.LINE_OFFSET, ctx);
    this.sliderHigher.draw(this.readingToCoordinate(BPWidget.DEFAULT_HIGHER_NUMBER), BPWidget.LINE_OFFSET, ctx);
    this.showLabels = true; 
    var pause = interval(2000).pipe(take(1));
    pause.subscribe(x => {
       this.drawLabels();
    });
  }  

  drawBackground(ctx, x: number, slider : number) {
      ctx.fillStyle = BPWidget.SLIDER_LOWER_COLOR;
      var slider1x = (slider == 1) ? x : this.sliderLower.x;
      var slider2x = (slider == 2) ? x : this.sliderHigher.x;
      ctx.fillRect(this.lineMargin, BPWidget.LINE_OFFSET, slider1x - this.lineMargin, 3);
      ctx.fillStyle = BPWidget.SLIDER_HIGHER_COLOR;
      ctx.fillRect(slider2x, BPWidget.LINE_OFFSET, 
          this.width - (slider2x + this.lineMargin), 3);
      ctx.fillStyle = BPWidget.NEUTRAL_COLOR;
      ctx.fillRect(slider1x, BPWidget.LINE_OFFSET, 
          slider2x - slider1x, 3);   
  }

  readingToCoordinate(reading : number) : number {
      return (reading * this.width) / 200;
  }

  coordinateToReading(coordinate : number) : number {
      return (coordinate * 200) / this.width;
  }    

    static getBloodPressureLabel(value : number) : string {
        if (value < 0) {
            return '';
        }
        else if (value < 37) {
          return "Low";
        } else if ((value >= 37) && (value < 56)) {
          return "Normal";
        }  else if ((value >= 56) && (value < 69)) {
           return "Elevated";
        } else if ((value >= 69) && (value < 80)) {
           return "High";
        }  else if ((value >= 80) && (value < 92)) {
           return "Very High";
        } else {
          return "Crisis";
        }
    }

    static setBloodPressureRating(diastolic : number, systolic : number)  : number {
      var ret : number = -1;   
      if ((diastolic != null) && (systolic != null)) {
        if ((systolic < 80) || (diastolic < 60)) {
            ret = 25;
        } else if ((systolic >= 80) && (systolic <120) && (diastolic >= 60) && (diastolic < 80)) {
            ret =50;
        } else if ((systolic >= 120) && (systolic <130) || (diastolic >= 60) && (diastolic < 80)) {
            ret = 62;
        } else if ((systolic >= 130) && (systolic <150) || (diastolic >= 80) && (diastolic < 90)) {
            ret =75;
        } else if ((systolic >= 140) && (systolic <180) || (diastolic >= 90) && (diastolic < 120)) {
            ret =87;
        } else if ((systolic >= 180)  || (diastolic >= 120)) {
            ret =100;
        }
      }
      return ret;
    }

    getYesterdaySystolic() : string {
        return (this.yesterdayValue / 1000).toFixed(0);
    }

    getYesterdayDiastolic() : string {
        let systolic : number = 1000 * (+this.getYesterdaySystolic());
        return (this.yesterdayValue - systolic).toFixed(0);
    }


    getYesterdayText() : string {
       return 'yesterday';
    }

}

export class Slider {

    x : number;
    y : number;
    selected : boolean = false;
    caller : BPWidget;
    initialized : boolean = false;
    color : string;

    static RADIUS : number = 10;
    static SELECTED_BORDER : number = 9;

    constructor(caller : BPWidget, color : string) {
        this.caller = caller;
        this.color = color;
    }

    contains(x : number, y : number) {
         // MobileLog.logClassLevel(0, 'BPWidget', ('x: ' + x + ', y: ' + y + ' vs. ' + 'x: ' + this.x + ', y: ' + this.y );
         return ((x >= this.x - Slider.RADIUS) && (x <= this.x + Slider.RADIUS) &&
                 (y >= this.y - Slider.RADIUS) && (y <= this.y + Slider.RADIUS))
    }

    draw(x : number, y: number, ctx) {

          if (this.isSelected()) {
               
              ctx.strokeStyle = this.color  + '40';
              ctx.lineWidth = Slider.SELECTED_BORDER;
          } else {
              ctx.strokeStyle = this.color;
              ctx.lineWidth = 0;
          }
         
          ctx.fillStyle = this.color ;  

          ctx.beginPath();
          ctx.arc(x, y, Slider.RADIUS,0,2*Math.PI);
          ctx.fill();
          if (this.isSelected())
              ctx.stroke();
          this.x = x;
          this.y = y;
    }

    setSelected(selected : boolean) {
        this.initialized = true;
        //MobileLog.logClassLevel(0, 'BPWidget','setting slider.isSelected=' + selected);
        this.selected = selected;
    } 

    isSelected() : boolean {
        return this.selected;
    }



}